
















import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

import Node from '@/models/Node';
import Mutations from '@/store/mutations';
import { SendPacket } from '@/networking/SendPacket';
import ProjectServer from '@/models/ProjectServer';
import { PacketType } from '@/models/Packet';
import DateOptions from '@/models/DateOptions';

@Component({})
export default class NodeDateOptionsSelector extends Vue
{
    @Prop(Node) readonly node! : Node;
    
    // ------ optional booleans to adjust behavior; can all be set as true just by adding the name to the html tag ------
    // mutateAndSendPacket, if specified as true, will send a mutation to Vuex and a packet to the ProjectServer on edits
    //  - should be true for editor, false for creator
    @Prop(Boolean) readonly mutateAndSendPacket! : boolean;

    DateOptions = DateOptions; // allows for static references in the HTML

    get editDateOptions() 
    {
        return this.node.dateOptions.valueOf();
    }
    set editDateOptions(value) 
    {
        if (this.mutateAndSendPacket)
        {
            this.$store.commit(Mutations.updateNodeDateOptions, { nodeid: this.node.nodeid, value: value });
            SendPacket(PacketType.NodeUpdateDateOptions, {nodeid: this.node.nodeid, value: this.node.dateOptions.valueOf()});
        }
        else
        {
            this.node.dateOptions = new DateOptions(value);
        }
        if (this.$refs.options != null)
        {
            this.$nextTick(() => {
                (this.$refs.options as any).focus();
            });
        }
    }
}
